import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export var BaseInputInfo = function BaseInputInfo(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    info = _ref.info;
  return /*#__PURE__*/_jsx("span", {
    className: clsx(className, 'tw-font-body5 tw-line-clamp-2 tw-w-full', {
      'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600': disabled,
      'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500': !disabled
    }),
    children: info
  });
};
export default BaseInputInfo;